import React, {useEffect, useState} from "react";
import {Dropdown, Menu} from "semantic-ui-react";
import {useIntl} from "react-intl";
import {find} from 'lodash';
import {useSelector} from "react-redux";

export const City = React.memo(({subdomain}) => {

    const [cities, setCities] = useState([]);

    const _cities = useSelector(state => state.Cities.results);

    useEffect(() => {
        async function fetchData() {
            const options = _cities.data
                .filter(o => !o.future)
                .map(function (city) {
                    return {
                        key: city.id,
                        text: city.name,
                        slug: city.slug,
                        value: city.id
                    };
                });
            setCities(options);
        }

        // noinspection JSIgnoredPromiseFromCall
        fetchData();

    }, [subdomain, _cities])

    const placeholder = useIntl().formatMessage({id: 'Trocar Cidade'});
    const city = JSON.parse(localStorage.getItem('_CITY'));

    return (
        <Menu.Item>
            <Dropdown
                placeholder={placeholder}
                selection
                options={cities}
                selectOnBlur={false}
                onChange={
                    (e, {value}) => {

                        let obj = find(cities, (o) => o.value === value);

                        localStorage.setItem('_CITY', JSON.stringify(obj));

                        window.location.href = '/';
                    }
                }
                value={city.value}
            />
        </Menu.Item>
    );
});
